export const buttonStyle = {
  backgroundColor: "#f3e1b2",
  color: "#000",
  border: "none",
  borderRadius: "12px",
  padding: "10px 20px",
  margin: "5px",
  cursor: "pointer",
  transition: "all 0.3s ease",
  transform: "scale(1)",
  fontFamily: "'Inter', sans-serif",
  fontWeight: "700",
  fontSize: "18px",
  letterSpacing: "0.5px",
  minWidth: "120px",
  width: "120px",
  "@media (max-width: 480px)": {
    fontSize: "14px",
    padding: "8px 15px",
    minWidth: "90px",
    width: "90px",
  },
};

export const circleButtonStyle = {
  width: "80px",
  height: "80px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "45px",
  padding: 0,
  border: "none",
  cursor: "pointer",
  transition: "all 0.3s ease",
  transform: "scale(1)",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  "@media (max-width: 480px)": {
    width: "60px",
    height: "60px",
    fontSize: "32px",
  },
};
